import { updateEvents } from '@/store/slices/swarms';
import { apiSlice } from '../app/api/apiSlice';
import queryString from 'query-string';

export const eventApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getEvents: builder.mutation({
      query: (eventsIds)=>({
        url: 'Event/EventsByIds',
        method: 'post',
        body: eventsIds
      }),
    }),
    getEvents: builder.query({
      query: (query)=> 'Event/EventsByIds' + query, // USAGE: ?bteId=1&bteId=2
      keepUnusedDataFor:10,
      providesTags: (result, error, arg) => {
        if(error || !result){
          return ['Event']
        }
        return [...result.map(({eventModel})=>['Event', {id:eventModel.bteId}])]
      },
      async onQueryStarted(queryArg, { dispatch, queryFulfilled }) {
       
        try {
          const { data } = await queryFulfilled
          // `onSuccess` side-effect
          console.log('getEvents, success: ', data)
          const events=  data.map( apiResponse => apiResponse.eventModel )
          dispatch(updateEvents(events))
        } catch (err) {
          // `onError` side-effect
          if (err.error?.originalStatus === 401) {
            // baseQueryWithReauth will handle the 401 error
            return
          }
          console.log('getEvents, error: ', err)
          throw err
        }
      },
    }),
    getUserBuys: builder.query({
      keepUnusedDataFor:0,
      query: ()=>({
        url: 'Event/UserBuys',
      })
    }),
    getEventBuys: builder.query({
      query: (query)=>({
        url: "event/buys/" + query,
      })
    }),
    getEventInsights: builder.query({
      query: (bteId)=>({
        url: `event/Insights/${bteId}`
      })
    }),
  })
})

export const { 
  useGetEventsMutation,
  useGetUserBuysQuery,
  useLazyGetUserBuysQuery,
  useGetEventsQuery,
  useLazyGetEventsQuery,
  useLazyGetEventBuysQuery,
  useGetEventInsightsQuery,
  useLazyGetEventInsightsQuery
} = eventApi;
